import PluginInterface, {PluginName} from '@/plugins/core/interface';
import PluginFactory from '@/plugins/core/plugin-factory';
import {ApiClientInterface} from '@/plugins/core/api/interface';
import IframeClient from '@/hosted_fields/common/connection/client';
import CommManagerInterface from '@/hosted_fields/master/interface';

class PluginManager {
  public apiClient: ApiClientInterface;
  public iframeClient: IframeClient;
  public commMgr: CommManagerInterface;

  public pluginRegistry: {
    [pluginName in PluginName]?: Promise<PluginInterface>;
  };

  registerPlugin(plugin: PluginName): Promise<PluginInterface> {
    if (this.isPluginLoaded(plugin)) {
      return Promise.resolve(this.pluginRegistry[plugin]);
    }
    this.pluginRegistry[plugin] = PluginFactory.create(plugin, this.commMgr).then((pluginInstance: PluginInterface) => {
      return pluginInstance.init().then(() => pluginInstance); // Return plugin instance after initialization
    });
    return this.pluginRegistry[plugin];
  }

  getPlugin(plugin: PluginName): Promise<PluginInterface> {
    return this.pluginRegistry[plugin];
  }

  isPluginLoaded(plugin: PluginName): Boolean {
    if (this.pluginRegistry[plugin]) return true;
    return false;
  }

  constructor(commMgr: CommManagerInterface) {
    this.commMgr = commMgr;
    this.apiClient = commMgr.apiClient;
    this.iframeClient = commMgr.connectionClient;
    this.pluginRegistry = {};
  }
}

export default PluginManager;
